app = angular.module('harriApp');

app.directive('userTagsPortal',function(){
  return {
    restrict: 'E',
    scope:{
      'tags' : '=',
    },
    templateUrl : '../modules/client_portal/views/partials/user-tags-portal.html',
    link: function( scope, element , attrs ){


        var newTah = scope.$watch('tags',function(newValue){
            if(newValue){
                _.defer(function() {
                    scope.hideTags();
                });
                newTah();
            }
        })
      /*
        *
        * Hack to hide tags for more than two lines (jQuery)
        *
        */
        scope.hideTags = function(){
            var candidateTagsSelector = '.candidate-tags';
            var singleCandidateTagSelector = '.tag';
            var tagListSelector = '.tags-list';
            var seeAllBtnSelector = '.see-all-btn';
            var TAGS_LIST_PADDING = 10;
            var _this = $(element).closest('.member-widget');
            var _thisTags = _this.find(candidateTagsSelector);

            if(!_thisTags.length){
              return;
            }
 
            /* find outer height of the tags */
            var _tagHeight = _thisTags.outerHeight();
            var _available_space = _this.outerHeight() - (TAGS_LIST_PADDING + _this.find('.candidate-widget-details').outerHeight() + _this.find('.short-list-buttons-wrapper').outerHeight() + _this.find('.tags-list-header').outerHeight());

            /* check if we need to do anything (when the tag list height is less than the available spcae */
            if(_tagHeight < _available_space){
              return;
            }

            var _tagsTop = _thisTags.offset().top;
            var _tagsBottom = _tagsTop + _available_space;

            _thisTags.find('li').each(function (){
                var _self = $(this);
                var tagBottom = _self.offset().top + _self.outerHeight(true);
                if(tagBottom >= _tagsBottom){
                    //console.log(_self,_this.attr('class'));
                     _self.addClass('not-visible');
                }
            });
            //set the new height
            //_thisTags.css( 'height', _available_space );
            //see more action
            _thisTags.closest(tagListSelector).find(seeAllBtnSelector)
                .show()
                .off('click')
                .on('click',function(){
                    if(_this.hasClass('all-tags')){
                      $(this).text($filter("translate")("view more"));
                    }else{
                      $(this).text($filter("translate")("view less"));
                    }
                    _this.toggleClass('all-tags');
                });
        }
      
    }
  }
})

